/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import Confetti from 'react-dom-confetti';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const RevealSelection = ({ children, confettiConfig }) => {
    const [active, setActive] = useState(false);
    useEffect(() => {
        setTimeout(setActive(true), 900);
        // eslint-disable-next-line
    }, []);

    return (
        <Styled.RevealContainer>
            <Styled.RevealAnimation>{children}</Styled.RevealAnimation>
            <Styled.ConfettiContainer>
                <Confetti active={active} config={confettiConfig} />
            </Styled.ConfettiContainer>
        </Styled.RevealContainer>
    );
};

RevealSelection.defaultProps = {
    children: <p>Item</p>,
    confettiConfig: {
        angle: 90,
        spread: 360,
        startVelocity: 35,
        elementCount: 550,
        dragFriction: 0.1,
        duration: 10000,
        stagger: 2,
        width: '10px',
        height: '10px',
        perspective: '600px',
        colors: ['#004226', '#fa6019']
    }
};

RevealSelection.propTypes = {
    children: PropTypes.element,
    confettiConfig: PropTypes.shape({
        angle: PropTypes.number,
        spread: PropTypes.number,
        startVelocity: PropTypes.number,
        elementCount: PropTypes.number,
        dragFriction: PropTypes.number,
        duration: PropTypes.number,
        stagger: PropTypes.number,
        width: PropTypes.string,
        height: PropTypes.string,
        perspective: PropTypes.string,
        colors: PropTypes.arrayOf(PropTypes.string)
    })
};

export default RevealSelection;
